import * as React from 'react';
import { useState, useEffect } from 'react';
import { useAtom } from 'jotai';
import { AnimatePresence, motion } from 'framer-motion';
import { sceneAtom, currentUrl, selectedName } from '../data/AtomData';
import sidebarData from "../data/sidebarData";

interface MainImageProps { }


export const MainImage: React.FC<MainImageProps> = (props: React.PropsWithChildren<MainImageProps>) => {
	const [scene, setScene] = useAtom(sceneAtom);
	const [activeUrl, setActiveUrl] = useAtom(currentUrl);
	const [currentNames, setCurrentNames] = useAtom(selectedName);
	const [currentImages, setCurrentImages] = useState<{ [index: string]: string }>({});

	useEffect(() => {
		const newImages: { [index: string]: string } = {};
		Object.entries(scene).forEach(([key, value]) => {
			newImages[key] = require(`../img/${ value[0]}`);
		});

		setCurrentImages(newImages);
	}, [scene]);


	const bCab = activeUrl.baseCabs;
	useEffect(() => {
		const splitCategory = sidebarData[0]?.splitCategory;
		const subMenu = splitCategory ? splitCategory[0]?.subMenu : undefined;

		if (subMenu && subMenu.length > 0) {
			for (let i = 0; i < subMenu.length; i++) {
				const childSubMenu = subMenu[i]?.childSubMenu;

				if (childSubMenu && childSubMenu.length > 0) {
					for (let c = 0; c < childSubMenu.length; c++) {
						const webCode = childSubMenu[c]?.webCode;

						if (bCab === webCode) {
							const imgCode = childSubMenu[c]?.mainImg;
							const nameCode = childSubMenu[c]?.text;
							setCurrentNames(names => names.map((item, index) => index === 0 ? nameCode : item))
							setScene(prevScene => ({
								...prevScene,
								"Base Cabinet Fronts": [imgCode || '']
							}));
							break;
						}
					}
				}
			}
		}
	}, [bCab, setScene]);

	const wCab = activeUrl.wallCabs;
	useEffect(() => {
		const splitCategory = sidebarData[0]?.splitCategory;
		const subMenu = splitCategory ? splitCategory[1]?.subMenu : undefined;

		if (subMenu && subMenu.length > 0) {
			for (let i = 0; i < subMenu.length; i++) {
				const childSubMenu = subMenu[i]?.childSubMenu;

				if (childSubMenu && childSubMenu.length > 0) {
					for (let c = 0; c < childSubMenu.length; c++) {
						const webCode = childSubMenu[c]?.webCode;

						if (wCab === webCode) {
							const imgCode = childSubMenu[c]?.mainImg;
							const nameCode = childSubMenu[c]?.text;
							setCurrentNames(names => names.map((item, index) => index === 1 ? nameCode : item));
							setScene(prevScene => ({
								...prevScene,
								"Wall Cabinet Fronts": [imgCode || '']
							}));
							break;
						}
					}
				}
			}
		}
	}, [wCab, setScene]);

	const hanOpt = activeUrl.handles;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[2].subMenu.length; i++) {
			const childSubMenuLength = sidebarData[2]?.subMenu[i]?.childSubMenu;

			if (childSubMenuLength !== undefined) {
				for (let c = 0; c < childSubMenuLength.length; c++) {
					const webCode = childSubMenuLength[c]?.webCode;
					if (hanOpt === webCode) {
						const imgCode = childSubMenuLength[c].mainImg;
						const nameCode = childSubMenuLength[c].text;
						setCurrentNames(names => names.map((item, index) => index === 3 ? nameCode : item))
						setScene(prevScene => ({
							...prevScene,
							"Handle Options": [imgCode || '']
						}));
						break;
					}
				}
			}
		}
	}, [hanOpt, setScene]);

	const flStyl = activeUrl.floor;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[3].subMenu.length; i++) {
			const webCode = sidebarData[3].subMenu[i]?.webCode;

			if (flStyl === webCode) {
				const imgCode = sidebarData[3].subMenu[i].mainImg;
				setScene(prevScene => ({
					...prevScene,
					"Flooring Style": [imgCode || '']
				}));
				break;
			}
		}
	}, [flStyl, setScene]);

	const wFin = activeUrl.wall;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[4].subMenu.length; i++) {
			const webCode = sidebarData[4].subMenu[i]?.webCode;

			if (wFin === webCode) {
				const imgCode = sidebarData[4].subMenu[i].mainImg;
				setScene(prevScene => ({
					...prevScene,
					"Wall Finish": [imgCode || '']
				}));
				break;
			}
		}
	}, [wFin, setScene]);

	const worktop = activeUrl.workSurface;
	useEffect(() => {
		for (let i = 0; i <= sidebarData[1].subMenu.length; i++) {
			const webCode = sidebarData[1].subMenu[i]?.webCode;

			if (worktop === webCode) {
				const imgCode = sidebarData[1].subMenu[i].mainImg;
				const nameCode = sidebarData[1].subMenu[i].text;
				setCurrentNames(names => names.map((item, index) => index === 2 ? nameCode : item))
				setScene(prevScene => ({
					...prevScene,
					"Worktop": [imgCode || '']
				}));
				break;
			}
		}
	}, [worktop, setScene]);

	if ((activeUrl.baseCabs !== "") || (activeUrl.wallCabs !== "") || (activeUrl.workSurface !== "") || (activeUrl.handles !== "") || (activeUrl.floor !== "") || (activeUrl.wall !== "")) {
		return (
			<div className="unity-config">
				{Object.entries(scene).map(([key, value], index) => (
					<AnimatePresence key={key}>
						<motion.img
							key={value[0]}
							src={currentImages[key]}
							alt={key}
							style={{ zIndex: index + 1 }}
							className={`${key === "Base Cabinet Fronts" ? "base_cabs" : key === "Wall Cabinet Fronts" ? "wall_cabs" : ""}${currentImages[key]?.includes("Handleless") ? "handrail" : ""}`}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={key === "Handle Options" ? { opacity: 0 } : { opacity: 0.9 }}
							transition={{ duration: 0.4 }}
						/>
					</AnimatePresence>
				))}
			</div>
		);
	}
	else {
		return (
			<div className="unity-config">
				{Object.entries(scene).map(([key, value], index) => (
					<AnimatePresence key={key}>
						<motion.img
							key={value[0]}
							src={currentImages[key]}
							alt={key}
							style={{ zIndex: index + 1 }}
							className={key === "Base Cabinet Fronts" ? "base_cabs" : key === "Wall Cabinet Fronts" ? "wall_cabs" : ""}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={key === "Handle Options" ? { opacity: 0 } : { opacity: 0.9 }}
							transition={{ duration: 0.4 }}
						/>
					</AnimatePresence>
				))}
			</div>
		);
	}	
};